/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

interface Props {
  text: string;
  onClick?: () => void | Promise<void>;
  className?: any;
  loading?: boolean;
  disabled?: boolean;
  name?: string;
  type?: any;
}

export const SubmitButton = ({ text = "Submit", className, onClick, loading, disabled, name = '', type }: Props): JSX.Element => {
  const { t } = useTranslation("common");
  return (
    <button
      className={`submit-button ${className}`}
      {...{ disabled }}
      onClick={onClick}
      name={name}
      type={type}
    >
      {!loading ? text : t("form.submitting")}
    </button>
  );
};

SubmitButton.propTypes = {
  text: PropTypes.string,
};
